import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { NgxSpinnerService } from 'ngx-spinner';
@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor(private Router: Router, private spinner: NgxSpinnerService) {}

  alertSuccess(message: any) {
    Swal.fire('Successful ', message, 'success');
  }

  ShowSpinner() {
    this.spinner.show();
  }

  HideSpinner() {
    this.spinner.hide();
  }

  alertError(message: any) {
    Swal.fire('Failed', message, 'error');
  }

  alertWarning(message: any) {
    Swal.fire('Warning', message, 'warning');
  }

  Unauthorize(message: string) {
    Swal.fire(' ! UnAuthorize Acccess ', message, 'error');
  }

  reloadComponent() {
    let currentUrl = this.Router.url;
    this.Router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.Router.onSameUrlNavigation = 'reload';
    this.Router.navigate([currentUrl]);
  }

  // Confirm popup
  confirmSignOutPopup(message: string) {
    return Swal.fire({
      title: message,
      showDenyButton: true,
      confirmButtonText: 'Continue',
      denyButtonText: 'Sign out',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        return true;
      } else if (result.isDenied) {
        return false;
      }
    });
  }

  // Confirm delete popup
  confirmDeletePopup(itemName: any) {
    return Swal.fire({
      confirmButtonColor: 'red',
      icon: 'warning',
      text: 'Are you sure you want to delete ' + itemName + '?',
      confirmButtonText: 'Yes, Delete',
      showCancelButton: true,
      showConfirmButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        return true;
      } else if (result.isDenied) {
        return false;
      }
    });
  }

  // Warning confirm popup
  confirmPopup(
    message: any,
    icon: any = 'warning',
    confirmButtonColor: string = 'green',
    confirmButtonText: string = 'Yes',
    cancelButtonText: string = 'Cancel'
  ) {
    return Swal.fire({
      confirmButtonColor: confirmButtonColor,
      icon: icon,
      text: message,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      showCancelButton: true,
      showConfirmButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        return true;
      } else if (result.isDenied) {
        return false;
      }
    });
  }
}
